import { graphql } from 'react-apollo';
import { connect } from 'react-redux';
import { GET_MEDIA_PARTNERS } from '../graphql/index';
import { changeMediaPartnersFilter } from '../actions/index';
// Components
import MediaPartnersWrapper from '../components/screens/mediaPartners/MediaPartnersWrapper';


const withData = graphql(GET_MEDIA_PARTNERS, {
  options: ({ filter }) => ({ variables: { filter } }),
  // eslint-disable-next-line no-unused-vars
  props: ({ ownProps, data }) => {
    const { loading, mediaPartners } = data;
    return { loading, medias: mediaPartners };
  },
});

const mapStateToProps = (state) => {
  return {
    locale: state.localeSelector,
    filter: state.mediaPartnersFilterSelector,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onFilterSubmit: (newFilter) => {
      dispatch(changeMediaPartnersFilter(newFilter));
    },
  };
};

const ContainerWithData = withData(MediaPartnersWrapper);
const MediaPartnersContainer = connect(mapStateToProps, mapDispatchToProps)(ContainerWithData);

export default MediaPartnersContainer;



/** WEBPACK FOOTER **
 ** ./src/containers/MediaPartnersContainer.js
 **/